import { render, staticRenderFns } from "./SummaryPerCrewAgeContainer.vue?vue&type=template&id=402c207b&scoped=true&"
import script from "./SummaryPerCrewAgeContainer.vue?vue&type=script&lang=js&"
export * from "./SummaryPerCrewAgeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c207b",
  null
  
)

export default component.exports